export const contextColors = {
  unistocks: 'rgb(0, 161, 224)',
  unistocksAlt: 'rgb(0, 83, 116)',

  bodyFont: 'rgb(237, 237, 237)',
  headingFont: 'rgb(164, 193, 209)',

  success: 'rgb(14, 184, 59)',
  danger: 'rgb(193, 0, 18)',
  info: 'rgb(13, 202, 240)',
  warning: 'rgb(240, 173, 78)',

  positive: 'rgb(0, 161, 224)',
  negative: 'rgb(193, 0, 18)'
};
